import React, {useContext, useEffect, useState} from "react";
import { useMetaMask } from "metamask-react";

import Icon from "../../../../components/Icon/Icon";

import ArrowRightIcon from "../../../../components/Icon/icons/account/ArrowRightIcon";

import AppConfig from "../../../../AppConfig";

import MetamaskConfirmationDialog from "../../wallet/MetamaskConfirmationDialog/MetamaskConfirmationDialog";
import WalletTermsDialog from "../../wallet/WalletTermsDialog/WalletTermsDialog";
import DownloadMetamaskDialog from "../../wallet/DownloadMetamaskDialog/DownloadMetamaskDialog";
import CodiaxContext from "../CodiaxContext";
import CodiaxHeader from "../CodiaxHeader/CodiaxHeader";

import s from "./CodiaxLogin.module.scss";
import cx from "classnames";
import {Button} from "reactstrap";
import {useHistory} from "react-router";
import {GNOSIS_POAP_ADDRESS} from "../Config";

const mintUrl = `https://poap.weavechain.com/codiax`;

export default function CodiaxLogin() {
	const { status } = useMetaMask();
	const history = useHistory();

	const [showDialog, setShowDialog] = useState(false);
	const [showDownloadDialog, setShowDownloadDialog] = useState(false);

	const { showConnect, connectToMetamask = () => {} } = useContext(CodiaxContext) || {};
	const showDownloadMetamask = status === "unavailable";

	// ------------------------------------- METHODS -------------------------------------
	const acceptTerms = () => {
		setShowDialog(false);

		// Not installed
		if (showDownloadMetamask) {
			setShowDownloadDialog(true);
		} else {
			connectToMetamask();
		}
	};

	const downloadMetamask = () => {
		setShowDownloadDialog(false);
		window.open(AppConfig.METAMASK_DOWNLOAD_URL, "_blank");
	};

	const onMint = () => {
		window.open(mintUrl, "_blank");
		history.push("/codiax/data");
	};

	const onRefresh = () => {
		window.location.reload()
	};

	return (
		<div className={s.root}>
			{status === "connecting" ? (
				<MetamaskConfirmationDialog theme="dark" />
			) : null}

			{showDialog ? (
				<WalletTermsDialog
					onContinue={acceptTerms}
					close={() => setShowDialog(false)}
					theme="dark"
				/>
			) : null}

			{showDownloadDialog ? (
				<DownloadMetamaskDialog
					theme="dark"
					onContinue={downloadMetamask}
					close={() => setShowDownloadDialog(false)}
				/>
			) : null}

			<CodiaxHeader showHelp/>

			<div className={s.content}>
				<div className={s.title}>Connect Wallet on Gnosis</div>
				<div className={s.description}>
					Connect with the same wallet where you minted your POAP, selecting the Gnosis chain from Metamask
				</div>
				<div className={s.description}>
					You can add Gnosis from <a href={"https://chainlist.org/"} target={"_blank"}>chainlist.org</a>
				</div>
				<div className={s.infoContainer}>
					<p className={s.subtitle} style={{ color: "white" }}>
						Gnosis POAP contract: <a href={GNOSIS_POAP_ADDRESS}>here</a>
					</p>
				</div>

				{showConnect ? (
					<div className={s.connectContainer}>
						<div className={s.foxContainer} onClick={() => /*setShowDialog(true)*/ connectToMetamask()}>
							<Icon icon="fox" />
							<div className={s.foxRighPanel}>
								<p className={s.meta}>Metamask</p>
								<p className={s.subTitle}>Connect using Metamask</p>
							</div>

							<ArrowRightIcon color={"#1cd0af"} />
						</div>

						<div className={s.download}>
							<p>
								Don't have a wallet?{" "}
								<a
									href={AppConfig.METAMASK_DOWNLOAD_URL}
									target="_blank"
									rel="noreferrer"
								>
									{" "}
									Download here
								</a>
							</p>
						</div>
					</div>
				): null}

				{!showConnect ? (
					<>
						<div>
							&nbsp;
						</div>
						<div className={s.description}>
							<Button
								className={cx(s.button, "btn-default dark")}
								color="primary"
								onClick={onMint}
							>
								Mint POAP
							</Button>
						</div>
						<div className={s.description}>
							<Button
								className={cx(s.button, "btn-default dark")}
								color="primary"
								onClick={onRefresh}
							>
								Refresh
							</Button>
						</div>
					</>
				) : null}
			</div>
		</div>
	);
}
